import type * as Api from '@ViewModels';

export interface ISelectableTag {
	selected: boolean;
	tag: string;
}

export function reconcileBrowsedTags(tags: ISelectableTag[], selectedTags: Api.IAccountTag[]): ISelectableTag[] {
	const selectedNames = new Set(selectedTags.map(tag => tag.name));
	const existingNames = new Set(tags.map(tag => tag.tag));
	const addedTags = selectedTags
		.filter(tag => !existingNames.has(tag.name))
		.map(tag => ({ selected: true, tag: tag.name }));
	const existingTags = tags.map(tag => ({ selected: selectedNames.has(tag.tag), tag: tag.tag }));
	return [...addedTags, ...existingTags];
}
